'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { CSSProperties, useEffect, useMemo, useState } from 'react';
import ModalCustomHeader from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/ModalCustomHeader';
import OmniDialog from '@/components/OmniDialog';
import ViverseCheckbox from '@/components/ViverseCheckbox';
import ViverseRadio from '@/components/ViverseRadio';
import { useGenreContext } from '@/context/GenreContext';
import { cn } from '@/lib/utils';
import { RoomTag } from '@/types/genre';
import { DeviceValue, WorldTypeValue } from '@/types/search';
const EMPTY_TAGS: RoomTag[] = [];
export type GenreDeviceFilterModalProps = {
  open: boolean;
  tag: string;
  type?: string;
  isSearchPage?: boolean;
  showDeviceSection?: boolean;
  title?: string;
  hideDevice?: boolean;
  hideType?: boolean;
  contentClassName?: string;
  contentStyle?: CSSProperties;
  device?: DeviceValue;
  onOpenChange: (open: boolean) => void;
  onDeviceChange?: (value: DeviceValue) => void;
  onFilterChange: (value: string) => void;
  onTypeChange?: (value: string) => void;
  onClearAll: () => void;
  filterTags?: RoomTag[];
};
export default function GenreDeviceFilterModal(t0) {
  const $ = _c(106);
  const {
    open,
    device,
    tag,
    type,
    isSearchPage,
    showDeviceSection: t1,
    title,
    hideDevice,
    hideType,
    contentClassName,
    contentStyle,
    onOpenChange,
    onDeviceChange,
    onFilterChange,
    onTypeChange,
    onClearAll,
    filterTags: t2
  } = t0;
  const showDeviceSection = t1 === undefined ? true : t1;
  const filterTags = t2 === undefined ? EMPTY_TAGS : t2;
  const t = useTranslations();
  const [selectedDevice, setSelectedDevice] = useState(device || "desktop");
  let t3;
  if ($[0] !== tag) {
    t3 = tag ? tag.split(",") : [];
    $[0] = tag;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [selectedGenres, setSelectedGenres] = useState(t3);
  const [selectedType, setSelectedType] = useState(type as WorldTypeValue ?? "all");
  const {
    tags
  } = useGenreContext();
  let t4;
  if ($[2] !== t) {
    t4 = t("worlds-landing.search.device.pc");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = {
      value: "desktop",
      label: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("worlds-landing.search.device.vr");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = {
      value: "vr",
      label: t6
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t("worlds-landing.search.device.ios");
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = {
      value: "ios",
      label: t8
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("worlds-landing.search.device.android");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = {
      value: "android",
      label: t10
    };
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t5 || $[20] !== t7 || $[21] !== t9) {
    t12 = [t5, t7, t9, t11];
    $[18] = t11;
    $[19] = t5;
    $[20] = t7;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const deviceOptions = t12;
  let t13;
  if ($[23] !== t) {
    t13 = t("worlds-landing.search.type.all");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = {
      value: "all",
      label: t13
    };
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t) {
    t15 = t("worlds-landing.search.type.world");
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15) {
    t16 = {
      value: "world",
      label: t15
    };
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t) {
    t17 = t("worlds-landing.search.type.video");
    $[31] = t;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17) {
    t18 = {
      value: "video",
      label: t17
    };
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t14 || $[36] !== t16 || $[37] !== t18) {
    t19 = [t14, t16, t18];
    $[35] = t14;
    $[36] = t16;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const typeOptions = t19;
  const genres = isSearchPage ? filterTags : tags;
  let t20;
  if ($[39] !== genres) {
    t20 = genres.map(_temp);
    $[39] = genres;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const genreOptions = t20;
  let t21;
  if ($[41] !== device || $[42] !== tag || $[43] !== type) {
    t21 = () => {
      setSelectedDevice(device || "desktop");
      setSelectedGenres(tag ? tag.split(",") : []);
      setSelectedType(type as WorldTypeValue ?? "all");
    };
    $[41] = device;
    $[42] = tag;
    $[43] = type;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== device || $[46] !== open || $[47] !== tag || $[48] !== type) {
    t22 = [device, tag, type, open];
    $[45] = device;
    $[46] = open;
    $[47] = tag;
    $[48] = type;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  useEffect(t21, t22);
  let t23;
  if ($[50] !== onDeviceChange) {
    t23 = value => {
      setSelectedDevice(value as DeviceValue);
      onDeviceChange?.(value as DeviceValue);
    };
    $[50] = onDeviceChange;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  const handleDeviceChange = t23;
  let t24;
  if ($[52] !== onTypeChange) {
    t24 = value_0 => {
      setSelectedType(value_0 as WorldTypeValue);
      onTypeChange?.(value_0);
    };
    $[52] = onTypeChange;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  const handleTypeChange = t24;
  let t25;
  if ($[54] !== onFilterChange || $[55] !== selectedGenres) {
    t25 = (value_1, checked) => {
      const newGenres = checked ? [...selectedGenres, value_1] : selectedGenres.filter(genre => genre !== value_1);
      setSelectedGenres(newGenres);
      onFilterChange(newGenres.join(","));
    };
    $[54] = onFilterChange;
    $[55] = selectedGenres;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  const handleGenreChange = t25;
  let t26;
  if ($[57] !== device || $[58] !== onClearAll) {
    t26 = () => {
      setSelectedDevice(device || "desktop");
      setSelectedGenres([]);
      onClearAll();
    };
    $[57] = device;
    $[58] = onClearAll;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  const handleClearAll = t26;
  let t27;
  if ($[60] !== contentClassName) {
    t27 = cn("lg:w-[900px] size-full lg:max-h-[729px] bg-[#212A3966] backdrop-blur-md shadow-2xl", contentClassName);
    $[60] = contentClassName;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== handleClearAll || $[63] !== title) {
    t28 = <ModalCustomHeader onClearAll={handleClearAll} title={title} />;
    $[62] = handleClearAll;
    $[63] = title;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== deviceOptions || $[66] !== handleDeviceChange || $[67] !== hideDevice || $[68] !== selectedDevice || $[69] !== showDeviceSection || $[70] !== t) {
    t29 = showDeviceSection && !hideDevice && <div className="flex flex-col gap-4"><h4 className="subheader-2">{t("worlds-landing.search.device.title")}</h4><ViverseRadio options={deviceOptions} value={selectedDevice} onValueChange={handleDeviceChange} className="flex-1 flex-row flex-wrap gap-4 px-0 md:px-4" optionRowClassName="md:basis-[30%] basis-[100%] md:py-[10px] py-0" wrapperClassName="flex-1 w-full" /></div>;
    $[65] = deviceOptions;
    $[66] = handleDeviceChange;
    $[67] = hideDevice;
    $[68] = selectedDevice;
    $[69] = showDeviceSection;
    $[70] = t;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== handleTypeChange || $[73] !== hideType || $[74] !== isSearchPage || $[75] !== selectedType || $[76] !== t || $[77] !== typeOptions) {
    t30 = !isSearchPage && !hideType && <div className="flex flex-col gap-4"><h4 className="subheader-2">{t("worlds-landing.search.type.title")}</h4><ViverseRadio options={typeOptions} value={selectedType} onValueChange={handleTypeChange} className="flex-1 flex-row flex-wrap gap-4 px-0 md:px-4" optionRowClassName="md:basis-[30%] basis-[100%] md:py-[10px] py-0" wrapperClassName="flex-1 w-full" /></div>;
    $[72] = handleTypeChange;
    $[73] = hideType;
    $[74] = isSearchPage;
    $[75] = selectedType;
    $[76] = t;
    $[77] = typeOptions;
    $[78] = t30;
  } else {
    t30 = $[78];
  }
  let t31;
  if ($[79] !== t) {
    t31 = t("worlds-landing.search.genre.title");
    $[79] = t;
    $[80] = t31;
  } else {
    t31 = $[80];
  }
  let t32;
  if ($[81] !== t31) {
    t32 = <h4 className="subheader-2">{t31}</h4>;
    $[81] = t31;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== genreOptions || $[84] !== handleGenreChange || $[85] !== selectedGenres) {
    let t34;
    if ($[87] !== handleGenreChange || $[88] !== selectedGenres) {
      t34 = option => <ViverseCheckbox key={option.value} id={`genre-${option.value}`} checked={selectedGenres.includes(option.value)} onCheckedChange={checked_0 => handleGenreChange(option.value, checked_0 as boolean)} containerClassName="md:basis-[30%] basis-[50%] md:py-[10px] py-0">{option.label}</ViverseCheckbox>;
      $[87] = handleGenreChange;
      $[88] = selectedGenres;
      $[89] = t34;
    } else {
      t34 = $[89];
    }
    t33 = genreOptions.map(t34);
    $[83] = genreOptions;
    $[84] = handleGenreChange;
    $[85] = selectedGenres;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[90] !== t33) {
    t34 = <div className="flex flex-row flex-wrap gap-4 px-0 md:px-4">{t33}</div>;
    $[90] = t33;
    $[91] = t34;
  } else {
    t34 = $[91];
  }
  let t35;
  if ($[92] !== t32 || $[93] !== t34) {
    t35 = <div className="flex flex-col gap-4">{t32}{t34}</div>;
    $[92] = t32;
    $[93] = t34;
    $[94] = t35;
  } else {
    t35 = $[94];
  }
  let t36;
  if ($[95] !== t29 || $[96] !== t30 || $[97] !== t35) {
    t36 = <div className="flex flex-col gap-6 overflow-y-auto pb-6 md:pb-0"><div className="flex flex-col gap-6">{t29}{t30}{t35}</div></div>;
    $[95] = t29;
    $[96] = t30;
    $[97] = t35;
    $[98] = t36;
  } else {
    t36 = $[98];
  }
  let t37;
  if ($[99] !== contentStyle || $[100] !== onOpenChange || $[101] !== open || $[102] !== t27 || $[103] !== t28 || $[104] !== t36) {
    t37 = <OmniDialog open={open} onOpenChange={onOpenChange} contentClassName={t27} contentStyle={contentStyle} withCloseButton={false} bodyClassName="md:px-10 md:py-8 p-4" headerClassName="px-4" customHeader={t28}>{t36}</OmniDialog>;
    $[99] = contentStyle;
    $[100] = onOpenChange;
    $[101] = open;
    $[102] = t27;
    $[103] = t28;
    $[104] = t36;
    $[105] = t37;
  } else {
    t37 = $[105];
  }
  return t37;
}
function _temp(t_0) {
  return {
    value: t_0.name,
    label: `${t_0.translations?.[0]?.name ?? t_0.name}`
  };
}